import { DEFAULT_HOTKEY_CONFIG } from '@/const/settings';
import { HotkeyId } from '@/types_cp/hotkey';
import { UserSettings } from '@/types_cp/user/settings';
import { merge } from '@/utils_cp/merge';

import { UserStore } from '../../../store';

export const currentSettings = (s: UserStore): UserSettings => merge(s.defaultSettings, s.settings);

const exportSettings = currentSettings;
const getHotkeyById = (id: HotkeyId) => (s: UserStore) =>
  merge(DEFAULT_HOTKEY_CONFIG, currentSettings(s).hotkey)[id];

export const settingsSelectors = {
  currentSettings,
  exportSettings,
  getHotkeyById,
};
